<div class="col-md-12">
  <app-alerting></app-alerting>
</div>
<app-collapse [collapse]="wasteCollectionTemplate" class="card card-body bg-light my-1" [showOnLoad]="newCollector">
  @if (summary) {
    <app-collector-summary-title-bar [summary]="summary"></app-collector-summary-title-bar>
  }
</app-collapse>
<ng-template #wasteCollectionTemplate>
  <div class="collapse">
    <div class="container px-0 mt-4">
      <div class="card">
        <div class="card-body">
          @if (newCollector && !summary) {
            <div class="row">
              <div class="col">
                <app-form-group>
                  <label for="newVisit">Search visit</label>
                  <app-search [ngModel]="summary" id="newVisit" (ngModelChange)="onVisitSelect($event)"
                              [searchFunction]="searchVisit"
                              [inputFormatter]="visitFormatter"></app-search>
                </app-form-group>
              </div>
              <div class="col">
                <button class="btn btn-secondary" (click)="cancelNewCollection()">Cancel</button>
              </div>
            </div>
          }

          @if (summary) {
            @if (!showRegisterCollection && !newCollector) {
              <!-- Overview -->
              <div class="d-none d-md-block">
                <div class="row">
                  <div class="col-4 fw-bold">Type</div>
                  <div class="col-4 text-center fw-bold">To be collected (m3)</div>
                  @if (summary.collections.length > 0) {
                    <div class="col-4 text-center fw-bold">Collected
                      (m3)
                    </div>
                  }
                </div>
                <hr>
                @for (item of allItems | keyvalue; track item) {
                  <div class="row mb-2">
                    <div class="col-4">{{ item.value.ssn.description }}
                      @if (item.value.specificationFromAgent) {
                        <app-info>
                          <span class="tooltipContent">{{ item.value.specificationFromAgent }}</span>
                        </app-info>
                      }
                    </div>
                    <div class="col-4 text-center">{{ item.value.quantityToBeCollected }}</div>
                    @if (summary.collections.length > 0) {
                      <div
                        class="col-4 text-center">{{ item.value.quantityCollected }}
                      </div>
                    }
                  </div>
                }
              </div>
              <!--  Collections-->
              @if (summary.collections.length > 0) {
                <hr>
                <div class="row mb-2">
                  <div class="col fw-bold">Collections</div>
                </div>
                @for (collection of summary.collections; track collection) {
                  <app-waste-collection (collectionCompleted)="handleCompletion()" [collection]="collection"
                                        [summary]="summary" [collector]="collector"></app-waste-collection>
                }
              }
            }
            <div #newCollectionEl>
              <!--NEW collection-->
              @if ((newCollection && showRegisterCollection) || newCollector) {
                <div class="row">
                  <div class="col-3 fw-bold">Type</div>
                  <div class="col-2 fw-bold text-center">To be collected (m3)</div>
                  <div class="col-2 fw-bold">Reception facility</div>
                  <div class="col-4"></div>
                  <div class="col-auto" style="min-width: 2.5em"></div>
                </div>
                <hr>
                @for (item of this.newCollection.items; track item; let idx = $index) {
                  <div class="row">
                    @if (item.wasteMaterial.ssn) {
                      <div class="col-3">
                        {{ item.wasteMaterial.ssn.description }}
                        @if (getSpecificationFromAgent(item)) {
                          <app-info><span
                            class="tooltipContent">{{ getSpecificationFromAgent(item) }}</span>
                          </app-info>
                        }
                      </div>
                    }
                    @if (!item.wasteMaterial.ssn) {
                      <div class="col-3">
                        <app-select [small]="true" [options]="wasteTypeOptions(this.newCollection)"
                                    [(ngModel)]="item.wasteMaterial.ssn"
                                    required [formatter]="utils.wasteTypeFormatter"></app-select>
                      </div>
                    }
                    <div class="col-2 text-center">{{ getToBeCollected(item.wasteMaterial.ssn) }}</div>
                    <div class="col-2 form-group mb-1">
                      <input required class="form-control form-control-sm" id="receptionFacility"
                             (ngModelChange)="setReceptionFacility(idx, $event)"
                             [(ngModel)]="item.receptionFacility"></div>
                    <div class="col-4"></div>
                    <div class="col text-end" style="min-width: 2em">
                      <span class="fa fa-trash text-secondary"
                            (click)="deleteItem(this.newCollection.items, idx)"></span>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col text-end">
                    <button [disabled]="!newCollection" (click)="addWasteItem(this.newCollection)"
                            class="btn btn-info mt-1 me-1" type="button">Add
                      Waste
                    </button>
                  </div>
                </div>
                <hr>
              }
              <!--          register pick up buttons -->
              @if (!showRegisterCollection) {
                <div class="row mt-2">
                  <div class="col-12 text-end">
                    <button (click)="addNewCollection()" class="btn btn-info me-1" type="button">
                      New Collection
                    </button>
                    @if (appContext.isAdmin()) {
                      <div class="dropdown always-enabled float-end">
                        <button class="btn btn-secondary" type="button" id="adminHamburgerMenu"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                          <!-- Hamburger menu icon -->
                          <i class="fa fa-user-shield" aria-hidden="true"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="adminHamburgerMenu">
                          <h6 class="dropdown-header" style="font-size: 18px;">Messages</h6>
                          <a href="#" (click)="$event.preventDefault(); openSwMessages()" class="dropdown-item">
                            WAR to Singlewindow
                          </a>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (showRegisterCollection || newCollector) {
                <div class="row">
                  <div class="col-6">
                    <app-form-group>
                      <label for="berthVisitId">Berth</label>
                      <app-select id="berthVisitId" [(ngModel)]="newCollection.berthVisitId" [options]="getBerthIds()"
                                  [formatter]="berthFormatter"></app-select>
                    </app-form-group>
                  </div>
                  <div class="col-6">
                    <app-form-group>
                      <label for="startTime">Start time</label>
                      <app-date-field required id="startTime" [(ngModel)]="newCollection.startTime"></app-date-field>
                    </app-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-end">
                    <button (click)="cancelNewCollection()" class="btn btn-secondary me-1" type="button">
                      Cancel
                    </button>
                    <button (click)="registerCollection()" class="btn btn-info me-1" type="button">
                      Register Collection
                    </button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>

      @if (summary) {
        <div class="card d-none d-md-block mt-2">
          <app-itinerary [berthVisits]="summary.berthVisits"></app-itinerary>
        </div>
      }
    </div>
  </div>
</ng-template>

